/**
 * Slider Animations using GSAP & Swiper
 */

export class SwiperAnimations {
  constructor() {
    this.init();
  }

  /**
   * Initialize animations
   */
  init() {
    if (typeof Swiper === "undefined") {
      console.warn("Swiper not loaded");
      return;
    }

    this.treatmentsSwiper();
    this.testimonialsSwiper();
    this.officeTourSwiper();
  }

  treatmentsSwiper() {
    const treatmentsSection = document.querySelector(".wps-treatments-slider");
    if (treatmentsSection) {
      const sliderEl = treatmentsSection.querySelector(
        ".wps-treatments-slider__track"
      );
      const btnPrev = treatmentsSection.querySelector(
        ".wps-treatments-slider__nav-btn--prev"
      );
      const btnNext = treatmentsSection.querySelector(
        ".wps-treatments-slider__nav-btn--next"
      );

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        speed: 500,
        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
        },
        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
          },
          699: {
            slidesPerView: 2,
          },
          576: {
            slidesPerView: 1.5,
          },
        },
      });

      // swiper.autoplay.pause();
    }
  }

  testimonialsSwiper() {
    const testimonialsSection = document.querySelector(
      ".wps-homepage-testimonials-section"
    );
    if (testimonialsSection) {
      const track = testimonialsSection.querySelector(
        ".wps-homepage-testimonials-section__content"
      );
      const slider = testimonialsSection.querySelector(
        ".wps-homepage-testimonials-cards-section__swiper"
      );
      if (!track || !slider) return;
      const btnPrev = testimonialsSection.querySelector(
        ".wps-homepage-testimonials-section__nav-button--prev"
      );
      const btnNext = testimonialsSection.querySelector(
        ".wps-homepage-testimonials-section__nav-button--next"
      );
      const container = testimonialsSection.querySelector(
        ".wps-homepage-testimonials-section-bg__overlay"
      );

      function calcLeftDistance() {
        const left = track.getBoundingClientRect().left;

        gsap.set(container, {
          width: left,
        });
      }
      calcLeftDistance();

      window.addEventListener("resize", calcLeftDistance);

      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        speed: 2000,
        autoplay: {
          // delay: 100,
          // disableOnInteraction: false,
        },
        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },
        // freeMode: true,
        // freeModeMomentum: false,

        breakpoints: {
          992: {
            slidesPerView: "auto",
          },
          699: {
            slidesPerView: 2,
          },
          576: {
            slidesPerView: 1.5,
          },
        },
      });
    }
  }

  officeTourSwiper() {
    const section = document.querySelector(
      ".wps-insidepage-office-tour-slider",
    );
    if (!section) return;

    const swiperEl = section.querySelector(
      ".wps-insidepage-office-tour-slider__swiper",
    );
    if (!swiperEl) return;

    const btnPrev = section.querySelector(
      ".wps-insidepage-office-tour-slider__nav-btn--prev",
    );
    const btnNext = section.querySelector(
      ".wps-insidepage-office-tour-slider__nav-btn--next",
    );
    const pagination = section.querySelector(
      ".wps-insidepage-office-tour-slider__pagination",
    );

    const enableAutoplay = swiperEl.dataset.autoplay === "true";

    const config = {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      speed: 600,
      navigation: {
        prevEl: btnPrev,
        nextEl: btnNext,
      },
      // pagination: {
      //   el: pagination,
      //   clickable: true,
      // },
      // breakpoints: {
      //   768: {
      //     slidesPerView: 2,
      //     spaceBetween: 24,
      //   },
      //   992: {
      //     slidesPerView: 1,
      //     spaceBetween: 30,
      //   },
      // },
    };

    if (enableAutoplay) {
      config.autoplay = {
        delay: 4000,
        disableOnInteraction: true,
      };
    }

    new Swiper(swiperEl, config);
  }
}
